import { Link } from "react-router-dom";
import { Zap, Flame, Wifi, FileText, RefreshCw, LogIn, MessageSquareWarning, CalendarClock, FileX, ArrowRight } from "lucide-react";

const services = [
  { icon: Zap, title: "Luce", desc: "Analisi e ottimizzazione del contratto di fornitura elettrica." },
  { icon: Flame, title: "Gas", desc: "Verifica tariffe e gestione del contratto gas." },
  { icon: Wifi, title: "Fibra", desc: "Confronto offerte internet e attivazione della connessione." },
  { icon: FileText, title: "Controllo bollette", desc: "Controlliamo le tue bollette per individuare errori e costi anomali." },
  { icon: RefreshCw, title: "Volture", desc: "Gestione del cambio di intestazione del contratto." },
  { icon: LogIn, title: "Subentri", desc: "Riattivazione della fornitura a tuo nome in modo semplice." },
  { icon: MessageSquareWarning, title: "Reclami", desc: "Ti assistiamo nella gestione dei reclami verso i fornitori." },
  { icon: CalendarClock, title: "Rateizzazioni", desc: "Supporto per rateizzare bollette elevate o insolute." },
  { icon: FileX, title: "Contratti non richiesti", desc: "Ti aiutiamo a contestare e annullare contratti attivati senza consenso." },
];

export default function Utenze() {
  return (
    <div data-testid="utenze-page">
      <section className="bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#10B981]">Utenze</span>
          <h1 className="mt-3 max-w-3xl font-display text-4xl font-extrabold tracking-tighter text-[#0A192F] sm:text-5xl">
            Assistenza completa su luce, gas e fibra
          </h1>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-slate-600">
            Dal controllo delle bollette alla gestione di volture e subentri, ViviTranquillo si occupa di
            tutte le tue utenze domestiche per farti risparmiare tempo e denaro.
          </p>
        </div>
      </section>

      <section className="bg-[#F8FAFC] py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((s) => (
              <div key={s.title} data-testid={`utenze-service-${s.title.toLowerCase().replace(/[^a-z]/g, "")}`} className="flex flex-col items-start gap-4 rounded-2xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)]">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#10B981]/10">
                  <s.icon className="h-5 w-5 text-[#10B981]" />
                </span>
                <h3 className="font-display text-lg font-bold text-[#0A192F]">{s.title}</h3>
                <p className="text-sm leading-relaxed text-slate-600">{s.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-12 rounded-2xl border border-slate-200 bg-white p-8 text-center">
            <h3 className="font-display text-2xl font-bold text-[#0A192F]">Vuoi aprire una richiesta utenze?</h3>
            <p className="mx-auto mt-2 max-w-xl text-slate-600">Con il Piano ViviTranquillo hai 3 richieste annuali e assistenza durante tutto l'anno.</p>
            <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
              <Link to="/area/richieste" data-testid="utenze-new-request" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#10B981] px-7 py-3 font-semibold text-white transition-colors hover:bg-[#059669]">
                Apri una richiesta <ArrowRight className="h-4 w-4" />
              </Link>
              <Link to="/piano" data-testid="utenze-piano" className="inline-flex items-center justify-center rounded-full border-2 border-slate-200 px-7 py-3 font-semibold text-[#0A192F] transition-colors hover:border-[#0A192F]">
                Scopri il Piano €49/anno
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
